import * as Sentry from "@sentry/react";
import { LogErrors } from "./LogErrors";

export const fetchAdditionalICEContacts = async (participantId, token) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}Profile/FetchAdditionalICEContacts?participantid=${participantId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorMsg = `Failed to fetch additional ICE contacts: ${response.status} - ${response.statusText}`;
      Sentry.captureMessage(errorMsg, "error");
      // LogErrors(user, logout, updateTokens, errorMsg);
      return null;
    }

    return await response.json();

  } catch (error) {
    // LogErrors(user, logout, updateTokens, "Error fetching additional ICE contacts:", error);
    Sentry.captureException(error);
    return null;
  }
};